import Masonry from './masonry.element.js';

export default Masonry;

Masonry.define('wje-masonry', Masonry);
